import React from "react";
import { Box, Typography } from "@mui/material";
import "../assets/css/SalesTrend/SalesTrendHeader.css";

interface SalesTrendHeaderProps {
  title?: string;
  userName?: string;
  location?: string;
  refreshTime?: string;
}

const SalesTrendHeader: React.FC<SalesTrendHeaderProps> = ({
  title,
  userName,
  location,
  refreshTime,
}) => {
  return (
    <Box className="trends">
      <Box className="header-container">
        {title && (
          <Box className="header-title">
            <Typography variant="h6" className="title-text">
              {title}
            </Typography>
          </Box>
        )}

        <Box className="header-info">
          {(userName || location) && (
            <Typography variant="body2" className="info-text">
              {userName && <strong className="info-strong">{userName}</strong>}
              {userName && location && " | "}
              {location}
            </Typography>
          )}

          {refreshTime && (
            <Typography variant="body2" className="info-text-right">
              <strong>Last refresh</strong> {refreshTime}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SalesTrendHeader;
